import { queryOptions } from "@tanstack/react-query";
import {
  KpiCatalogResponseSchema,
  type KpiCatalogEntry,
  type KpiCatalogResponse,
} from "@nexus/contracts";
import { authFetch } from "@/lib/api-client";

export type KpiCatalogScope = "dashboard" | "overview" | "drilldown";

export const kpiCatalogKeys = {
  all: ["kpi-catalog"] as const,
  scope: (scope: KpiCatalogScope, tenantId: string) =>
    ["kpi-catalog", scope, tenantId] as const,
  tenant: (tenantId: string) => ["kpi-catalog", "tenant", tenantId] as const,
};

async function fetchKpiCatalog(scope: KpiCatalogScope): Promise<KpiCatalogResponse> {
  const { data } = await authFetch<KpiCatalogResponse>(`/${scope}/kpis`);
  return KpiCatalogResponseSchema.parse(data);
}

export function kpiCatalogQueryOptions(scope: KpiCatalogScope, tenantId: string) {
  return queryOptions({
    queryKey: kpiCatalogKeys.scope(scope, tenantId),
    queryFn: () => fetchKpiCatalog(scope),
    enabled: !!tenantId,
    staleTime: 60_000,
  });
}

export async function fetchTenantKpis(tenantId: string): Promise<KpiCatalogEntry[]> {
  const { data } = await authFetch<KpiCatalogResponse>("/tenant-kpis", {
    headers: { "X-Tenant-Id": tenantId },
  });
  return KpiCatalogResponseSchema.parse(data);
}

export function tenantKpisQueryOptions(tenantId: string) {
  return queryOptions({
    queryKey: kpiCatalogKeys.tenant(tenantId),
    queryFn: () => fetchTenantKpis(tenantId),
    enabled: !!tenantId,
    staleTime: 0,
  });
}
